/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AppSkeletonImage } from '../../common/ui';
import accessBannerSVG from './assets/access-banner-actions-skeleton.tpl.svg';
import issuePermissionsSVG from './assets/issue-permissions-dialog-actions-skeleton.tpl.svg';
import rolesPickerSVG from './assets/roles-picker-actions-skeleton.tpl.svg';

const customCssStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: 0,
		borderLeftWidth: 0,
	},
});

export const IssuePermissionsDialogActionsSkeleton = () => (
	<AppSkeletonImage
		src={issuePermissionsSVG}
		css={customCssStyles}
		containerStyles={{ height: '32px' }}
	/>
);
export const AccessBannerActionsSkeleton = () => (
	<AppSkeletonImage
		src={accessBannerSVG}
		css={customCssStyles}
		containerStyles={{ height: '32px' }}
	/>
);

export const RolesPickerActionsSkeleton = () => (
	<AppSkeletonImage
		src={rolesPickerSVG}
		css={customCssStyles}
		containerStyles={{ height: '32px', marginTop: token('space.150', '12px') }}
	/>
);
